import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import { thoughtspot } from 'config';
import LiveboardVisuals from 'components/common/LiveboardVisuals';
import { filterByAssetOwner } from 'components/pages/Insights/LabsReportDropdown/utils';
import { Store } from 'components/common/types/Store.types';
import { initialiseThoughtspot } from 'utils/thoughtspotInit';
import { thoughtspotMetricsStyles } from '../styles';

type LiveboardVisualMetricProps = {
  vizId: string;
  icon: string;
  name: string;
};

const LiveboardVisualMetric: React.FC<LiveboardVisualMetricProps> = ({ vizId, icon, name }) => {
  const navigate = useNavigate();

  const { localeCode } = useSelector((state: Store) => state.publisher.configuration);
  const { marketId, timezone, timezoneOverride } = useSelector((state: Store) => state.publisher.configuration);

  const [isMetricsLiveboardVisible, setIsMetricsLiveboardVisible] = useState(true);

  initialiseThoughtspot(localeCode);

  if (!isMetricsLiveboardVisible) return null;

  return (
    <div className="relative flex w-full h-20 group">
      <div
        className="w-full h-full absolute group-hover:cursor-pointer z-20"
        role="presentation"
        data-test-id="liveboard-navigate-overlay"
        onClick={() => {
          navigate('/insights');
        }}
      />
      <div className="z-10 h-20 flex w-full px-4 py-3">
        <SVG src={icon} className="mt-0.5 mr-2" />
        <div className="flex flex-1 flex-col">
          <p className="body-sm text-neutral-900 mb-0.5">{name}</p>
          <LiveboardVisuals
            liveboardId={thoughtspot.dealManagementMetrics}
            customizations={thoughtspotMetricsStyles}
            visibleActions={[]}
            filterByOptions={[filterByAssetOwner(marketId)]}
            onLiveboardError={() => {
              setIsMetricsLiveboardVisible(false);
            }}
            runtimeParameters={[{ name: 'Timezone', value: timezoneOverride ?? timezone }]}
            visualId={vizId}
            frameStyles="border-none bg-transparent h-8 max-h-8 z-10"
          />
        </div>
      </div>
      <div className="w-full h-full absolute z-0 bg-neutral-50 rounded-lg border border-neutral-300 group-hover:bg-primary-50 group-hover:border-primary-600-opacity-60" />
    </div>
  );
};

export default LiveboardVisualMetric;
